import * as d3 from 'd3';
import { DataRenderer } from './DataRenderer';
import { ChartRenderer } from './ChartRenderer';
import { tbPalette } from 'styles/colors';

export class HighlightRenderer extends DataRenderer {
  constructor(
    private gElement: d3.Selection<SVGGElement, unknown, null, undefined>,
    private removeOuterSpacing?: boolean,
    private highlightLineColor?: string,
    private forceInlineStyles: boolean = false
  ) {
    super();
  }

  public render(x: d3.ScaleBand<string>, y: d3.ScaleLinear<number, number>) {
    const height = y.range()[0];

    const rects = this.gElement
      .selectAll('.highlight-lines')
      .data([x.domain()])
      .enter()
      .append('g')
      .attr('class', 'highlight-lines')
      .selectAll('highlight-line')
      .data(d => d)
      .enter()
      .append('rect')
      .attr('class', 'guide highlight-line')
      .style('fill', () => this.highlightLineColor ?? null)
      .attr('width', '1')
      .attr('height', Math.max(height, 0))
      .attr('x', (d, index) => (x(d) || 0) + ChartRenderer.getBandSpacing(x, index, !!this.removeOuterSpacing))
      .attr('y', '0')
      .attr('z', '0');

    if (this.forceInlineStyles) {
      rects
        .style('fill', () => this.highlightLineColor ?? tbPalette.surface.grey)
        .style('opacity', 0)
        .attr('width', '2');
    }
  }

  public switchHighlight(index: number, highlight: boolean) {
    const targetNodes = this.gElement.select('.highlight-lines').selectAll('.guide').nodes() as HTMLElement[];

    targetNodes.forEach(node => {
      node.classList.remove('show');
      if (this.forceInlineStyles) {
        node.style.opacity = '0';
      }
    });
    if (highlight) {
      if (targetNodes.length === 0) {
        return;
      }
      targetNodes[index].classList.add('show');
      if (this.forceInlineStyles) {
        targetNodes[index].style.opacity = '1';
      }
    }
  }
}
